import { DataError, Either, UseCase } from '@robotrader/core-lib';

import {
  MultiScalperV1UseCaseProps,
  TradingSignal,
  TradingSignalRepository,
} from '@/modules/trader/domain';

interface GetMultiScalpingV1SimulationUseCaseProps {
  tradingSignalRepository: TradingSignalRepository;
}

export class GetMultiScalpingV1SimulationUseCase
  implements
    UseCase<MultiScalperV1UseCaseProps, Either<DataError, TradingSignal[]>>
{
  private tradingSignalRepository: TradingSignalRepository;

  constructor({
    tradingSignalRepository,
  }: GetMultiScalpingV1SimulationUseCaseProps) {
    this.tradingSignalRepository = tradingSignalRepository;
  }

  execute(
    props: MultiScalperV1UseCaseProps,
  ): Promise<Either<DataError, TradingSignal[]>> {
    return this.tradingSignalRepository.simulateMultiScalpingV1(props);
  }
}
